import { useTranslation } from "react-i18next"
import { graphql, useFragment } from "react-relay"
import { Phone, VideoCamera } from "@phosphor-icons/react"
import { formatDate } from "@/lib/format-date"
import { getSlotLabel } from "@/lib/slot"
import { appointmentDrawerCardHeader_appointment$key } from "@/modules/common/waiting-room/appointment/__generated__/appointmentDrawerCardHeader_appointment.graphql"

const AppointmentDrawerCardHeaderFragment = graphql`
  fragment appointmentDrawerCardHeader_appointment on Appointment {
    slotId
    channel
    service
    date
  }
`

type AppointmentDrawerCardHeaderProps = {
  appointmentRef: appointmentDrawerCardHeader_appointment$key
}

const AppointmentDrawerCardHeader = ({ appointmentRef }: AppointmentDrawerCardHeaderProps) => {
  const { t } = useTranslation()

  const { slotId, channel, service, date } = useFragment<appointmentDrawerCardHeader_appointment$key>(
    AppointmentDrawerCardHeaderFragment,
    appointmentRef,
  )
  return (
    <div className="flex items-center gap-4">
      {channel === "VIDEO" && <VideoCamera />}
      {channel === "PHONE" && <Phone />}
      <div className="grid">
        <div className="flex items-center gap-2">
          <span className="text-on-surface truncate text-base font-medium" data-testid="appointment-service-name">
            {t(`scheduling.waitingRoom.service.${service}`)}
          </span>
        </div>
        <div className="flex gap-1">
          <span data-testid="appointment-date">{formatDate(new Date(date))}</span>
          <span data-testid="appointment-time">{getSlotLabel(slotId)}</span>
        </div>
      </div>
    </div>
  )
}

export { AppointmentDrawerCardHeader }
